<template>
  <main>
    <div class="main">
      <div class="section-frame">
        <div class="main-frame">
          <div class="main-content">
            <h1>
              {{ $t("home_hero_title") }} <br />
              {{ $t("home_hero_title_2") }}
            </h1>
            <p v-if="!user">
              {{ $t("home_hero_login_message") }}
            </p>
            <router-link v-if="!user" to="/login"
              ><div>{{ $t("login") }}</div>
              <i class="fa-out"></i
            ></router-link>
            <a v-else href="/courses" @click.prevent="upTop('/courses')"
              ><div>{{ $t("all_courses") }}</div>
              <i class="fa-arrow-line"></i
            ></a>
          </div>
          <img
            src="../assets/images/advantages/hero.png"
            class="main-photo"
            alt=""
          />
          <router-link v-if="!user" to="/login" class="main-btn mob-content">
            <div>{{ $t("login") }}</div>
            <i class="fa-out"></i>
          </router-link>
        </div>
      </div>
    </div>
    <div class="advantages">
      <div class="section-frame">
        <div class="advantages-list">
          <div class="advantages-item">
            <div class="advantages-photo">
              <img
                src="../assets/images/advantages/boy-front-clay.png"
                alt=""
              />
            </div>
            <p>
              {{ $t("advantage_1") }}
            </p>
          </div>
          <div class="advantages-item">
            <div class="advantages-photo">
              <img
                src="../assets/images/advantages/travel-front-clay.png"
                alt=""
              />
            </div>
            <p>
              {{ $t("advantage_2") }}
            </p>
          </div>
          <div class="advantages-item">
            <div class="advantages-photo">
              <img
                src="../assets/images/advantages/fav-folder-front-clay.png"
                alt=""
              />
            </div>
            <p>
              {{ $t("advantage_3") }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="courses">
      <div class="section-frame">
        <div class="page-sub-title">
          <h2>
            <i class="fa-title"></i>
            <div>
              {{ $t("courses_greeting") }}
            </div>
          </h2>
        </div>
        <div class="courses-list" v-if="courses">
          <CoursesCard
            v-for="item in courses.result"
            :key="item.id"
            :data="item"
            :finish="true"
          />
        </div>
        <div class="courses-list loading" v-else>
          <v-loader />
        </div>

        <a
          href="/courses"
          @click.prevent="upTop('/courses')"
          class="courses-all-btn"
          ><div>{{ $t("all_courses") }}</div>
          <i class="fa-arrow-line"></i
        ></a>
      </div>
    </div>
    <div class="certified">
      <div class="section-frame">
        <div class="certified-frame">
          <div class="certified-content">
            <div class="page-sub-title">
              <h2>
                <i class="fa-title"></i>
                <div>
                  {{ $t("certificated_courses") }}
                </div>
              </h2>
            </div>
            <p class="certified-descriptor">
              {{ $t("certificated_courses_description") }}
            </p>
            <a
              href="/certified-courses"
              @click.prevent="upTop('/certified-courses')"
              class="content-button-new"
              ><div>{{ $t("all_courses") }}</div>
              <i class="fa-arrow-line"></i
            ></a>
          </div>
          <div class="courses-wrapp" v-if="certificatedCourses">
            <div
              class="courses-slider empty"
              v-if="certificatedCourses.result === null"
            >
              <p>{{ $t("certificated_courses_empty") }}</p>
            </div>
            <VueSlickCarousel
              v-else-if="certificatedCourses.result"
              v-bind="settings"
              class="courses-slider"
            >
              <div
                v-for="data in certificatedCourses.result"
                :key="data.id"
                class="courses-item courses-slide"
                :class="{
                  'courses-item-finish':
                    data.status && data.status.toUpperCase() === 'FINISHED',
                }"
              >
                <div
                  v-if="
                    (data.status && data.status.toUpperCase() === 'FINISHED') ||
                    (data.status && data.status.toUpperCase() === 'NEW') ||
                    (data.status &&
                      data.status.toUpperCase() === 'DOWNLOADING') ||
                    (data.status && data.status.toUpperCase() === 'PROGRESS')
                  "
                  class="courses-item-status"
                  :class="{
                    'status-work':
                      data.status && data.status.toUpperCase() === 'PROGRESS',
                    'status-finish':
                      data.status && data.status.toUpperCase() === 'FINISHED',
                    'status-new':
                      data.status && data.status.toUpperCase() === 'NEW',
                    'status-load':
                      data.status &&
                      data.status.toUpperCase() === 'DOWNLOADING',
                  }"
                >
                  <img
                    v-if="
                      data.status && data.status.toUpperCase() === 'PROGRESS'
                    "
                    src="../assets/images/status/work.svg"
                    alt=""
                  />
                  <img
                    v-if="
                      data.status && data.status.toUpperCase() === 'FINISHED'
                    "
                    src="../assets/images/status/finish.svg"
                    alt=""
                  />
                  <img
                    v-if="data.status && data.status.toUpperCase() === 'NEW'"
                    src="../assets/images/status/new.svg"
                    alt=""
                  />
                  <img
                    v-if="
                      data.status && data.status.toUpperCase() === 'DOWNLOADING'
                    "
                    src="../assets/images/status/load.svg"
                    alt=""
                  />
                  <span
                    v-if="
                      data.status && data.status.toUpperCase() === 'PROGRESS'
                    "
                    >{{ $t("status_progress") }}</span
                  >
                  <span
                    v-if="
                      data.status && data.status.toUpperCase() === 'FINISHED'
                    "
                    >{{ $t("status_finished") }}</span
                  >
                  <span
                    v-if="data.status && data.status.toUpperCase() === 'NEW'"
                    >{{ $t("status_new") }}</span
                  >
                  <span
                    v-if="
                      data.status && data.status.toUpperCase() === 'DOWNLOADING'
                    "
                    >{{ $t("status_downloading") }}</span
                  >
                </div>
                <div
                  class="courses-item-photo"
                  @click.prevent="upTop(`/certified/${data.id}`)"
                >
                  <img :src="$mediaUrl(data.image_url)" alt="" />
                  <div
                    v-if="
                      data.status && data.status.toUpperCase() === 'PROGRESS'
                    "
                    class="courses-item-progres"
                  >
                    <span
                      class="progres-line"
                      :style="`width: ${(data.finished_lessons_count / data.lessons_count) * 100}%;`"
                    ></span>
                  </div>
                </div>
                <div class="courses-item-content">
                  <div
                    class="courses-info"
                    @click.prevent="upTop(`/certified/${data.id}`)"
                  >
                    <p>{{ data.category }}</p>
                    <a :href="`/certified/${data.id}`">{{ data.name }}</a>
                    <p
                      class="courses-info__length"
                      v-if="data.sub_courses && data.sub_courses.length"
                      style=""
                    >
                      {{ data.sub_courses.length }}{{ $t("courses_count") }}
                    </p>
                  </div>
                  <div class="courses-purchase">
                    <a
                      :href="`/certified/${data.id}`"
                      @click.prevent="upTop(`/certified/${data.id}`)"
                      class="courses-btn"
                      >{{ $t("read") }}</a
                    >
                  </div>
                </div>
              </div>
              <template #prevArrow>
                <span class="slider-arrow slider-arrow-prev courses-prev">
                  <i class="fa-arrow-prev"></i>
                </span>
              </template>
              <template #nextArrow>
                <span class="slider-arrow slider-arrow-next courses-next">
                  <i class="fa-arrow-next"></i>
                </span>
              </template>
            </VueSlickCarousel>
            <div v-else class="courses-slider">
              <v-loader />
            </div>
          </div>
          <a
            href="/certified-courses"
            @click.prevent="upTop('/certified-courses')"
            class="certified-mob"
            ><div>{{ $t("all_courses") }}</div>
            <i class="fa-arrow-line"></i
          ></a>
        </div>
      </div>
    </div>
    <!-- <div class="referal-program"> -->
    <!-- <div class="section-frame">
        <div class="referal-program-content">
          <img
            src="../assets/images/referal.jpg"
            class="referal-program-photo"
            alt="" -->
    <!-- /> -->
    <!-- <div class="referal-program-info">
            <div class="page-sub-title referal-program-title">
              <h2>
                <i class="fa-title"></i>
                <div>{{ $t("partnership_title") }}</div>
              </h2>
            </div>
            <p>{{ $t("hand_shake") }}</p> -->
    <!-- <router-link :to="user ? '/invite' : '/login'" class="desc-referal"
              ><div>{{ $t('join') }}</div>
              <i class="fa-arrow-line"></i
            ></router-link> -->
    <!-- </div> -->
    <!-- </div> -->
    <!-- <router-link :to="user ? '/invite' : '/login'" class="mob-referal"
          ><div>{{ $t('join') }}</div>
          <i class="fa-arrow-line"></i
        ></router-link> -->
    <!-- </div> -->
    <!-- </div> -->
    <div class="news" v-if="news && news.result">
      <div class="section-frame">
        <div class="page-sub-title sub-title-white">
          <h2>
            <i class="fa-title"></i>
            <div>{{ $t("news") }}</div>
          </h2>
        </div>
        <p class="news-descriptor">
          {{ $t("news_description") }}
        </p>

        <div class="news-wrapp">
          <VueSlickCarousel v-bind="settings_news" class="news-slider">
            <div
              class="news-slide news-item"
              v-for="(item, index) in news.result"
              :key="index"
            >
              <div class="news-photo">
                <img
                  :src="
                    item.image_url
                      ? $mediaUrl(item.image_url)
                      : require('../assets/images/news/news.jpg')
                  "
                  alt=""
                />
              </div>
              <div class="news-info">
                <div class="news-item-title">
                  <h3>{{ item.title }}</h3>
                  <p v-extract v-html="$processHtml(item.content)"></p>
                </div>
                <div class="news-date">
                  <div>
                    {{ item.date_created }}
                  </div>
                  <router-link :to="`/news/${item.slug}`">{{
                    $t("read")
                  }}</router-link>
                </div>
              </div>
            </div>
            <template #prevArrow>
              <span class="slider-arrow slider-arrow-prev courses-prev">
                <i class="fa-arrow-prev"></i>
              </span>
            </template>
            <template #nextArrow>
              <span class="slider-arrow slider-arrow-next courses-next">
                <i class="fa-arrow-next"></i>
              </span>
            </template>
          </VueSlickCarousel>
        </div>

        <router-link to="/news" class="news-all"
          ><div>{{ $t("all_news") }}</div>
          <i class="fa-arrow-line"></i
        ></router-link>
      </div>
    </div>
  </main>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import CoursesCard from "@/components/CoursesCard";
export default {
  title: "Asosiy",
  name: "Home",
  data() {
    return {
      settings: {
        slidesToShow: 2,
        infinite: true,
        adaptiveHeight: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
      settings_news: {
        infinite: true,
        slidesToShow: 4,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
  methods: {
    upTop(e) {
      window.scrollTo(0, 0);
      this.$router.push(e);
    },
  },
  async mounted() {
    await this.$store.dispatch("certificatedCourses", { page: 1 });

    try {
      await this.$store.dispatch("getCoursesHome");
    } catch (e) {
      console.log(e);
    }
    try {
      await this.$store.dispatch("getNews");
    } catch (e) {
      console.log(e);
    }
  },
  computed: {
    news() {
      return this.$store.getters.getNews;
    },
    user() {
      return this.$store.getters.getUserCredentials;
    },
    courses() {
      return this.$store.getters.getCoursesHome;
    },
    certificatedCourses() {
      return this.$store.getters.getCertificatedCourses;
    },
  },
  components: {
    VueSlickCarousel,
    CoursesCard,
  },
};
</script>
